import { z } from 'zod';
import { InitialStateSchema } from './InitialState';
import { TriggerIdSchema } from './TriggerId';
import { SlideContentSchema } from './SlideType';

export const ContentSchema = z.object({
  slides: z.array(SlideContentSchema),
  initialState: InitialStateSchema,
  triggerIds: z.array(TriggerIdSchema),
});

export type Content = z.infer<typeof ContentSchema>;
